import React from 'react';
import { Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { checkPermission } from '../utils/checkPermission';
import { BANNER_STATUS_CHANGE, POPUP_STATUS_CHANGE } from '../constants/apiEndPoint';

const ModalConfirm = ({ Confirm, handleApprove, selectedRowKeys, actionType, roles }) => {
  const handleClose = () => {
    Confirm(false);
  };

  const handleConfirm = () => {
    // Format the data according to the API expectations
    const data = {
      id: selectedRowKeys.join(','), // Convert array to comma-separated string
      status: actionType === 'disapprove' ? 1 : 0,
    };

    handleApprove(data);
    Confirm(false);
  };

  return (
    <div className="flex justify-center items-center fixed top-0 left-0 w-full h-full z-[99] bg-[rgba(0,0,0,0.5)]">
      <div className="bg-white border border-white w-[500px] h-[230px] rounded-lg shadow-md relative z-[100] p-[24px] flex flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="mb-4">
            <InfoCircleOutlined className="text-[60px] text-yellow-500" />
          </div>
          <div className="mb-2">
            <h3 className="font-roboto text-[16px] font-medium leading-5 tracking-[0.005em]">Thông báo</h3>
          </div>
          <div className="mb-6">
            <span>Bạn có chắc chắn muốn cập nhật các {roles} đã chọn không?</span>
          </div>
          <div className="flex justify-center">
            <Button className="mr-3" color="default" variant="outlined" onClick={handleClose}>
              <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">Hủy bỏ</span>
            </Button>
            {checkPermission(roles === 'popup' ? POPUP_STATUS_CHANGE : BANNER_STATUS_CHANGE, 'Duyệt') && (
              <Button color="primary" variant="solid" onClick={handleConfirm}>
                <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">Xác nhận</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
